import styled, { css } from 'styled-components'
import { xsMd } from '../../../theme/utils/media-query'
import { spacing_1, spacing_1_5 } from '../../../theme/spacing'
import { gray_6 } from '../../../theme/colors';

export function makeHamburger (element) {
  return styled(element)`
    width: 25px;
    height: 20px;
    position: relative;
    margin: ${ spacing_1_5 } 0;
    transform: rotate(0deg);
    transition: .5s ease-in-out;
    cursor: pointer;
    display: none;

    div {
      display: block;
      position: absolute;
      height: 3px;
      width: 100%;
      background: ${ gray_6 };
      border-radius: 3px;
      opacity: 1;
      left: 0;
      transform: rotate(0deg);
      transition: .25s ease-in-out;
    }

    div:nth-child(1) {
      top: 0px;
    }

    div:nth-child(2),div:nth-child(3) {
      top: 7px;
    }

    div:nth-child(4) {
      top: 14px;
    }

    &.open div:nth-child(1) {
      top: 7px;
      width: 0%;
      left: 50%;
    }

    &.open div:nth-child(2) {
      transform: rotate(45deg);
    }

    &.open div:nth-child(3) {
      transform: rotate(-45deg);
    }

    &.open div:nth-child(4) {
      top: 7px;
      width: 0%;
      left: 50%;
    }

    ${xsMd(css`
      {
        display: block;
        margin: ${ spacing_1 } 0;
      }
    `)}
  `
}

export default makeHamburger